export default __webpack_public_path__ + "static/media/404-not-found-background.48077729.jpg";